var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.errorResponse &&
    _vm.errorResponse.errors &&
    Object.values(_vm.errorResponse.errors).length > 0
    ? _c(
        "div",
        { staticClass: "grid gap-y-8" },
        _vm._l(_vm.errorResponse.errors, function(error, index) {
          return _c("div", { key: index, staticClass: "error-msg" }, [
            _c(
              "div",
              { staticClass: "error-txt my-auto" },
              [
                error[0] === "Het files veld is verplicht."
                  ? [
                      _vm._v(
                        "Upload hier je CV, motivatiebrief, ... is verplicht"
                      )
                    ]
                  : [_vm._v(_vm._s(error[0]))]
              ],
              2
            )
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }